
import { Button } from '@/components/ui/button';
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
} from '@/components/ui/card';
import { Comment } from '@/types/board';
import { ThumbsUp } from 'lucide-react';
import { useQueryClient } from '@tanstack/react-query';
import { toggleCommentLike } from '@/services/postService';
import { useToast } from '@/hooks/use-toast';

interface CommentItemProps {
  comment: Comment;
  formatDate: (date: string) => string;
  postId: string;
  user: any;
}

export const CommentItem = ({ comment, formatDate, postId, user }: CommentItemProps) => {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  
  const handleLike = () => {
    if (!user) {
      toast({
        description: "좋아요를 누르려면 로그인이 필요합니다."
      });
      return;
    }
    
    toggleCommentLike(comment.id, comment.like_count + 1)
      .then(() => {
        queryClient.invalidateQueries({ queryKey: ['comments', postId] });
      })
      .catch(() => {
        toast({
          variant: "destructive",
          title: "오류가 발생했습니다",
          description: "좋아요를 처리하는데 실패했습니다."
        });
      });
  };
  
  return (
    <Card key={comment.id}>
      <CardHeader className="pb-2">
        <div className="flex justify-between items-center">
          <div>
            <p className="text-sm font-medium">{comment.author_name}</p>
            <p className="text-xs text-muted-foreground">{formatDate(comment.created_at)}</p>
          </div>
        </div>
      </CardHeader>
      <CardContent>
        <p className="text-sm">{comment.content}</p>
      </CardContent>
      <CardFooter className="pt-0 pb-2">
        <Button 
          variant="ghost" 
          size="sm" 
          className="text-xs"
          onClick={handleLike}
        >
          <ThumbsUp className="h-3 w-3 mr-1" />
          좋아요 ({comment.like_count})
        </Button>
      </CardFooter>
    </Card>
  );
};
